module.exports = __webpack_public_path__ + "img/nav_icon_settings_dk.418c951c.svg";